import { DataTableSetting } from './DataTableSetting';
import { DataTableField } from './DataTableField';
import { FieldEnum } from './FieldEnum';

export class SearchContractDataTableSetting extends DataTableSetting {
  public onContractMatched?: Function;

  public static init(sortBy: string,
    sortDirection: string,
    fields: DataTableField[],
    items: any[] | Function,
    showCheckbox?: boolean,
    isRowClickSelected?: boolean): SearchContractDataTableSetting {
    const setting = new SearchContractDataTableSetting({
      sortBy,
      sortDirection,
      fields,
      items,
      isRowClickSelected,
    });
    if (showCheckbox) {
      setting.fields.unshift({
        key: 'checkbox',
        label: 'checkbox',
        type: FieldEnum.FIELD_CHECKBOX,
        sortable: false,
        thClass: 'checkbox-header',
      });
    }
    return setting;
  }

  constructor(init?: Partial<DataTableSetting>) {
    super(init);
    Object.assign(this, init);
  }

}
